import { render, staticRenderFns } from "./TablePerson.vue?vue&type=template&id=55cf2b00"
import script from "./TablePerson.vue?vue&type=script&lang=js"
export * from "./TablePerson.vue?vue&type=script&lang=js"
import style0 from "./TablePerson.vue?vue&type=style&index=0&id=55cf2b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports